import { EidEasySigningMethod } from './signingMethods';

/**
 * Investor address country (ISO 3166-1 alpha-2) → the eID-backed method(s) native to
 * that country, per eID Easy's own geography (docs.eideasy.com/supported-methods).
 * Sweden lists two because Freja is a widely used Swedish alternative to Swedish BankID.
 */
export const COUNTRY_SIGNING_METHOD_GROUPS: Readonly<Record<string, EidEasySigningMethod[]>> = {
	SE: [EidEasySigningMethod.SE_BANKID, EidEasySigningMethod.FREJA],
	FI: [EidEasySigningMethod.FTN],
	NO: [EidEasySigningMethod.NORWEGIAN_BANKID],
	DK: [EidEasySigningMethod.MITID],
	EE: [EidEasySigningMethod.SMART_ID],
	LV: [EidEasySigningMethod.SMART_ID],
	LT: [EidEasySigningMethod.SMART_ID],
};

/**
 * Narrows an already-eligible method list down to the one(s) native to the signer's
 * country, for the initial (collapsed) view of the method picker. Falls back to OTP when
 * the country has no dedicated method, isn't recognized, or its method(s) aren't eligible
 * for this signer — and, failing that, returns `methods` untouched.
 */
export const resolveCountryRestrictedMethods = (
	methods: EidEasySigningMethod[],
	countryCode?: string | null
): EidEasySigningMethod[] => {
	const group = countryCode ? COUNTRY_SIGNING_METHOD_GROUPS[countryCode.toUpperCase()] ?? [] : [];
	const eligibleGroupMethods = group.filter((method) => methods.includes(method));
	if (eligibleGroupMethods.length > 0) {
		return eligibleGroupMethods;
	}
	return methods.includes(EidEasySigningMethod.OTP) ? [EidEasySigningMethod.OTP] : methods;
};
